import { firebaseDataOperationConfig } from '@/js/constants';
import firebase from 'firebase/app';
var firebaseDataOperationInstance = null;
export default {
  getFirebaseDataOperation: function getFirebaseDataOperation() {
    if (firebaseDataOperationInstance !== null) {
      return firebaseDataOperationInstance;
    }
    firebaseDataOperationInstance = firebase.initializeApp(firebaseDataOperationConfig, 'firebaseDataOperation');
    return firebaseDataOperationInstance;
  }
};